import { render, staticRenderFns } from "./AliPayButton.vue?vue&type=template&id=f6e046dc&scoped=true&"
import script from "./AliPayButton.vue?vue&type=script&lang=ts&"
export * from "./AliPayButton.vue?vue&type=script&lang=ts&"
import style0 from "./AliPayButton.vue?vue&type=style&index=0&id=f6e046dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e046dc",
  null
  
)

export default component.exports